export const API_SERVER = 'https://ref-server.cinemabox.team';
export const API_PORT = '';
export const API_PATH = 'api';
export const API_VERSION = 'v1';
